"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexContainer = exports.CashBackLabel = exports.CashBackIconLayout = exports.CashBackContainer = exports.CashBackAmount = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var CashBackContainer = exports.CashBackContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__CashBackContainer",
  componentId: "sc-1g6aitd-0"
})(["display:flex;align-items:center;background-color:", ";border-radius:20px 8px;color:", ";line-height:1.4;font-size:", "px;padding:0 8px;&.withBorder{border:1px solid;}"], function (_ref) {
  var labelColor = _ref.labelColor;
  return labelColor;
}, function (_ref2) {
  var textColor = _ref2.textColor;
  return textColor;
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'l' ? 12 : 10;
});
var CashBackLabel = exports.CashBackLabel = _styledComponents["default"].span.withConfig({
  displayName: "styles__CashBackLabel",
  componentId: "sc-1g6aitd-1"
})(["margin-right:3px;"]);
var CashBackAmount = exports.CashBackAmount = _styledComponents["default"].b.withConfig({
  displayName: "styles__CashBackAmount",
  componentId: "sc-1g6aitd-2"
})(["padding-top:2.5px;padding-bottom:2.5px;font-size:1.072em;"]);
var CashBackIconLayout = exports.CashBackIconLayout = _styledComponents["default"].div.withConfig({
  displayName: "styles__CashBackIconLayout",
  componentId: "sc-1g6aitd-3"
})(["align-items:center;display:flex;margin-left:3px;width:max-content;"]);
var FlexContainer = exports.FlexContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__FlexContainer",
  componentId: "sc-1g6aitd-4"
})(["display:flex;"]);